<template>
  <div class="processing-loader">
    <div class="cup">
      <div class="liquid"></div>
    </div>
    <h2 class="title">Preparando seu pedido...</h2>
    <p class="subtitle">
      Aguarde um instante, estamos gerando seus tickets.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProcessingLoader'
}
</script>

<style lang="less" scoped>
.processing-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 12px;
  margin-top: 20px;
}

.cup {
  width: 80px;
  height: 90px;
  border: 5px solid #dcdcdc;
  border-top: none;
  border-radius: 0 0 20px 20px;
  position: relative;
  margin-bottom: 20px;
  overflow: hidden;
}

.liquid {
  background-color: var(--primaryColor);
  width: 100%;
  height: 0%;
  position: absolute;
  bottom: 0;
  animation: fillUp 2.5s ease-in-out infinite;

  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: -110px;
    width: 200px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 45%;
    animation: wave 2s linear infinite;
  }
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.subtitle {
  font-size: 14px;
  color: #666;
  max-width: 280px;
  line-height: 1.5;
  margin: 0;
}

@keyframes fillUp {
  0% {
    height: 0%;
  }
  50% {
    height: 100%;
  }
  100% {
    height: 0%;
  }
}

@keyframes wave {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100px);
  }
}
</style>
